module.exports = __webpack_public_path__ + "img/i10.8ea11a12.png";